<template>
  <b-form class="container">
    <div class="box">
      <h2>{{ $t('parametros-de-analise') }}</h2>
      <span>
        <label for="manipulatedVariableMapping">{{ $t('variavel-manipulada') }}</label><br>
        <select class="input-pentagro" id="manipulatedVariableMapping" v-model="sensitivityAnalysisModel.manipulatedVariableMapping">
          <option value="" selected>{{ $t('selecione-uma-variavel-manipulada') }}</option>
          <option v-for="(maneuverVariable, index) in maneuverVariables" :key="index"
            :value="maneuverVariable.mapping">
            {{maneuverVariable.name}}
          </option>
        </select>
      </span>
      
      <span>
        <label for="processVariableMapping">{{ $t('variavel-objetivo') }}</label><br>
        <select class="input-pentagro" id="processVariableMapping" v-model="sensitivityAnalysisModel.processVariableMapping" @change="setNameSeries">
          <option value="" selected>{{ $t('selecione-uma-variavel-objetivo') }}</option>
          <option v-for="(processVariable, index) in processVariables" :key="index"
            :value="processVariable.mapping">
            {{processVariable.name}}
          </option>
        </select>
      </span>
      
    </div>

    <div class="box2">
      <h2>{{ $t('configuracoes') }}</h2>
      <span>
        <label for="initialValue">{{ $t('valor-inicial') }} </label>
        <input class="input-pentagro" id="initialValue" v-model="sensitivityAnalysisModel.initialValue" type="number"/>
      </span>

      <span>
        <label for="finalValue">{{ $t('valor-final') }} </label>
        <input class="input-pentagro" id="finalValue" v-model="sensitivityAnalysisModel.finalValue" type="number"/>
      </span>

      <span>
        <label for="step">{{ $t('passo') }}</label>
        <input class="input-pentagro"  id="step" v-model="sensitivityAnalysisModel.step" type="number"/>
      </span>
    </div>

    <div class="box3">
      <h2>{{ $t('status-0') }}</h2>
      <div class="msg"></div>
      </div>

    <apexchart class="box4" id="chart" ref="chart" type="line" :options="chartOptions" :series="series"></apexchart>

    <footer>
      <Loading2 class="loading" v-bind:caption="msgLoading" />
      <MessageBox 
        class='msgBox' 
        style="display: none;" 
        :header="$t('atencao')"
        v-bind:info="sucessSimulation.info" 
        v-bind:question="sucessSimulation.question" 
        v-bind:action="applyDiagram" 
      />

      <img
      id="closeModal"
      src="@/assets/sair.png"
      :title="$t('cancelar')"
      :alt="$t('cancelar')"
      @click="$bvModal.hide(nameModel)"
      />

      <img
          id="stopSimulatorImage"
          src="@/assets/stop.png"
          :title="$t('parar-simulacao')"
          :alt="$t('parar-simulacao')"
          @click="setStopSimulation.stopStimulation()"
        />

      <img
          id="simulate"
          src="@/assets/play.png"
          :title="$t('executar-simulacao')"
          :alt="$t('executar-simulacao')"
          @click="doSensitivityAnalysis()"
        />
    </footer>
  </b-form>
</template>

<script>
import axios from 'axios'
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import Loading2 from "@/components/template/Loading2";
import MessageBox from "@/components/template/MessageBox";
import VueApexCharts from "vue-apexcharts";

export default {
      name: "SensitivityAnalysis",

      components: { Loading2, MessageBox,  apexchart: VueApexCharts },

      props: [ "table" , "tableResultSensitivityAnalysis", "loadTableOutputSensitivityAnalysis", "nameModel" ],
      
      inject: ['setStopSimulation', 'stateOfSimulation'],

      data() {
        return {
          sucessSimulation: {
              info: "",
              question: "",
            },
          msgLoading: this.$t('simulando'),
          checked: true,
          showWait: false,
          maneuverVariables: [],
          processVariables: [],
          sensitivityAnalysisModel: {
            table: [],
            tableFlowChart: [],
            manipulatedVariableMapping : "",
            processVariableMapping : "",
            initialValue : 0,
            finalValue : 0,
            step :0,
          },
					series: [{
              name: this.$t('variavel-objetivo'),
              data: []
						}],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            xaxis: {
              categories: [],
            }
          },
        }
      },

      methods: {
        setNameSeries(){
          let varObjective = this.processVariables.find( o => o.mapping == this.sensitivityAnalysisModel.processVariableMapping)
          if(varObjective){
            this.series[0].name = varObjective.name
            this.$refs.chart.updateSeries(this.series)
          }
        },

        //Carrega o modelo SensitivityAnalysis
        loadSensitivityAnalysisData: () => 
          axios.get(`${urlMainAPI}/loadsensitivityanalisysdata`).then(d => d.data).catch(e => console.log('Falha na requisição da api', e)),

        // Envia o objetivo Para API
        async doSensitivityAnalysis() {
          this.cleanChart()
          this.showWait = true;
          let sensitivityAnalysis = {};
          
          this.msgLoading = "Simulando..."
          this.blockFilds(true)
          await this.loadSensitivityAnalysisData()
            .then(data => sensitivityAnalysis = data)
            .catch(e => console.log("Falha na carga da do modelo SensitivityAnalysis. ", e));

          if (!localStorage.xml) {
            try {
              await axios.get(`${urlMainAPI}/loadactivesimulationscenario`)
                .then(res => {
                  if(res.status == 200){
                    let xml = {}
                    xml.name = res.data.name
                    xml.scenario = res.data.scenario
                    xml.scenarioResult = res.data.scenarioResult
                    
                    this.$store.commit("setXML", xml);
                    localStorage.setItem("xml", JSON.stringify(xml));
                  }
                }).catch(console.error);
            } catch (error) {
              showError(this.$t('problema-ao-carregar-o-modelo-ativo'));
            }
          }

          Object.assign(sensitivityAnalysis)
          sensitivityAnalysis.callSensitivityAnalysis= true
          sensitivityAnalysis.scenario = JSON.parse(localStorage.getItem("xml")).scenario;
          sensitivityAnalysis.scenarioResult = JSON.parse(localStorage.getItem("xml")).scenarioResult;
          sensitivityAnalysis.manipulatedVariableMapping = this.sensitivityAnalysisModel.manipulatedVariableMapping;
          sensitivityAnalysis.processVariableMapping = this.sensitivityAnalysisModel.processVariableMapping;
          sensitivityAnalysis.initialValue = parseFloat(this.sensitivityAnalysisModel.initialValue);
          sensitivityAnalysis.finalValue = parseFloat(this.sensitivityAnalysisModel.finalValue);
          sensitivityAnalysis.step = parseFloat(this.sensitivityAnalysisModel.step);
          sensitivityAnalysis.x = [0, 0, 0];
            
          document.querySelector(".msg").innerHTML = "";
          this.setStopSimulation.refreshToken();
          console.log('this.setStopSimulation :>> ', this.setStopSimulation);
          defaultSuccess(this.$t('iniciando-simulacao'));
          this.stateOfSimulation(true)
          
          await axios.post(`${urlMainAPI}/dosensitivityanalisys`, sensitivityAnalysis, { cancelToken: this.setStopSimulation.executeRequest.token})
            .then(d => d.data)
            .then(data => {
              this.updateChart(data)
              return this.findSolution(data)
            })
            .catch(e => {
              console.log("DoSensitivityAnalysis ->" + e)
              this.blockFilds(false);
              this.stateOfSimulation(false)
            })
        },

        // Atualiza o Box
        findSolution: async function (data) {
          // Verificando se foi encontrado solução para o objetivo
          console.log("Verificando resultados", data)
          document.querySelector(".msg").innerHTML = ""
          data.message.forEach(msg => {
            let element = document.createElement("p")
            element.style.margin = "0"
            element.innerHTML = msg.replace("sim_status", this.$t('status-3')).replace("res", this.$t('resultado')).replace("x", this.$t('valor-0')).replace("it", this.$t('iteracao')).replaceAll("=", " =")
            document.querySelector(".msg").append(element)
          });
          this.setStopSimulation.refreshToken();
      
          if (data.status === 1) {
            this.blockFilds(false);
            defaultSuccess(this.$t('analise-concluida-em') + `${data.iteraction}` + this.$t('interacoes'));
            this.stateOfSimulation(false)
            return data;
          }
          else if (data.status === -1) {
            console.log("Solução Não encontrada: ")
            data.message.forEach(console.log)
            this.blockFilds(false);
            showError(this.$t('nao-foi-possivel-encontrar-uma-solucao'))
            this.stateOfSimulation(false)
            return data;
          }
          else {
            this.blockFilds(true);
            await axios.post(`${urlMainAPI}/dosensitivityanalisys`, data, { cancelToken: this.setStopSimulation.executeRequest.token})
              .then(d => {
                this.updateChart(d.data)
                this.findSolution(d.data)
              })
              .catch(e => {
                this.blockFilds(false);
                console.log("Solução Não encontrada:", e)
                return data;
              })
          }
        },

        updateChart(data){
          let _data = []
                for( let i = 0 ; i < data.yAxisValue.length; i++){
                  _data.push({
                    x: data.xAxisValue[i],
                    y: data.yAxisValue[i],
                  })
                }
                this.$refs.chart.updateSeries([{data:_data}])
        },

        cleanChart(){
            this.$refs.chart.updateSeries([{data:[]}])
        },

        // Abre a caixa de mensagem de sucesso
        openMessage() {
            document.querySelector('.msgBox').style.display = 'flex'
        },          


        // Aplica as configurações após ter encontrado a solução do Atingir metas
        applyDiagram: async function () {
          document.querySelector('.msgBox').style.display = "none";
          this.msgLoading = this.$t('carregando')
          this.blockFilds(true);

          let obj = {
            scenario: this.sensitivityAnalysisModel.scenario,
            scenarioResult: this.sensitivityAnalysisModel.scenarioResult,
            table: this.table,
            tableResult: this.tableResultSensitivityAnalysis,
            inputMapping: null
          }
          this.callCalculationSimulation(obj, this.showLoading)

          this.$bvModal.hide(this.nameModel);

          this.blockFilds(false);
        },
        //Bloqueia Campos enquanto simula
        blockFilds: (stop) => {
          if (stop) {
            document.querySelectorAll("input").forEach(e => e.setAttribute("disabled", "disabled"))
            document.querySelectorAll("select").forEach(e => e.setAttribute("disabled", "disabled"))
            document.querySelector('#simulate').style.display = "none";
            document.querySelector('#stopSimulatorImage').style.display = "flex";
            document.querySelector('.loading').style.display = 'flex';
          } else {
            document.querySelectorAll("input").forEach(e => e.removeAttribute("disabled", "disabled"))
            document.querySelectorAll("select").forEach(e => e.removeAttribute("disabled", "disabled"))
            document.querySelector('#simulate').style.display = "block";
            document.querySelector('#stopSimulatorImage').style.display = "none";
            document.querySelector('.loading').style.display = 'none';
          }
        }
      },
      created() {
        //Carrega seletores de variáveis objetivo e simulada
        axios.get(`${urlMainAPI}/getmaneuvervariable`).then(d => d.data)
          .then( maneuver => this.maneuverVariables = maneuver);
        axios.get(`${urlMainAPI}/getprocessvariable`).then(d => d.data)
          .then(process => this.processVariables = process);
      },
      destroyed() {
        this.blockFilds(false)
        if (this.stateOfSimulation('state')){
          this.setStopSimulation.stopStimulation()
          this.stopStimulation.refreshToken()
          this.stateOfSimulation(false)
        }
      },
}
</script>

<style scoped>

div {
display: flex;
flex-direction: column;
align-items: top;
justify-content: center;
border: 1px solid rgba(72, 69, 87, 0.212);
padding: 5px 5px;
border-radius: 4px;
}

.container {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-template-rows: 25vh 20vh 15vh 5vh;
  gap: 10px;
  width: 100%;
  max-width: 1000px;
  padding: 0;
  margin: -5px;
}

.containter>div {
border-bottom: 1px solid #ccc;
}

.head h1{
  font-size: 1.1em;
  display: flex;
  padding: 5px 10px;
  margin: 0;
}

.container h2 {
  font-size: 1.05em;
  float: left;
  margin: 0;
}

.box {
  grid-row-start: 1;
  display: flex;
  justify-content: space-evenly;
}

.loading{
border: none;
display: none;
}

.box label, .box2 label,.box3 label {
float: left;
margin: 0;
}

.box select{
  float: left;
  margin: 2px 5px;
  width: 95%;
  height: 26px;
}

.box input {
margin: 1px 5px;
float: right;
width: 130px;
}

.box2 {
  text-align: left;
  grid-row-start: 2;
  grid-column-start: 1;
  display: flex;
  justify-content: space-evenly;
}


.box2 h2 {
  margin-bottom: 10px;
}


.box2 input {
float: right;
}

.box2 input:focus{
  outline: 0;
  border-radius: 2px;
  border: 2px solid rgb(103, 163, 216);
  box-shadow: 0 1px 3px rgb(103, 163, 216);
}

.box2 input:nth-child(1){
  float: left;
  margin: 6px 10px;
}

.box3 {
  grid-row-start: 3;
  grid-column-start: 1;
  justify-content: start;
  grid-column-end: span 2;
  text-align: left;
  align-self: start;
  height: 100%;
  overflow-y: auto;
}

.box4{
	grid-row-start: span 2;
	grid-column-start: 2;
}

.box3>div {
  border: none;
}

.msg {
  margin-top: 2px;
  justify-content: start;
  overflow: hidden;
  overflow-y: scroll;
}

.msg::-webkit-scrollbar{
display: none;
}

footer{
grid-row-start: 4;
grid-column-start: 1;
grid-column-end: span 2;
}

footer>p{
grid-row-start: 3;
grid-column-start: 1;
float: left;
}

footer>img{
float: right;
margin-right: 20px;
cursor: pointer;
max-height: 35px;
max-width: 35px;
}

footer>img#loadingEntries{
cursor: default;
}

#stopSimulatorImage{
display: none;
max-height: 35px;
border-radius: 7px;
padding: 3px;
align-self: flex-start;
}

.msgBox{
top: calc(50% - 210px )
}

@media (max-width: 990px) { 
  .container {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 215px 270px 1fr 10vh 40px;
  width: 100%;
  height: 100%;
  min-width: 310px;
}
.box {
  grid-row-start: 1;
}
.box2 {
  grid-row-start: 2;
  grid-column-start: 1;
}
.box3 {
  grid-row-start: 4;
}

.box4 {
  grid-column-start: 1;
  grid-row-start: 3;
}


footer{
  grid-row-start: 5;
  grid-column-start: 1;
}

}

@media (max-width: 360px) { 
  .container {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 230px 520px 1fr 40px;
  width: 100%;
  height: 100%;
  min-width: 310px;
}

.box {
  grid-row-start: 1;
}


.box2 {
  grid-row-start: 2;
  grid-column-start: 1;
}

.box {
  justify-content: space-between;
}

.box>select {
  margin: 0 10px;
}
.box2>span {
  display: flex;
  flex-direction: column;
}

.box2>span:last-child {
  flex-direction: row;
}

.box2>span>input {
  margin: 3px;
}

.box3 {
  grid-row-start: 3;
}

footer{
  grid-row-start: 4;
  grid-column-start: 1;
}

}
</style>